import { defineComponent as _defineComponent } from 'vue'
import ProductRegistrationSearchProductTile from './ProductRegistrationSearchProductTile.vue';
import productRegistrationService from '@/services/product-registration.service';
import PageService from '@/core/page.service';
import { computed, ref, watch } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogSearchPage',
  props: {
    registerProductDetailsUrl: null
  },
  setup(__props: any) {



const isPrivateMode = computed<boolean>(() => store.getters['app/isPrivateMode']);
const searchActive = ref<boolean>(false);
const term = ref<string>('');

const isSearching = ref<boolean>(false);
const results = ref<ProductRegistrationProductTileViewModel[]>([]);

const defaultSearchResult = computed<ProductRegistrationProductTileViewModel>(() => {
    return {
        backgroundColor: isPrivateMode.value ? '#f6f6f6' : '#ffffff',
        category: '',
        defaultImageUrl: '',
        displayName: term.value,
        productId: '',
        url: ''
    };
});

watch(() => term.value, onTermChange);

async function onTermChange(term: string) {
    isSearching.value = true;
    productRegistrationService.search(term)
        .then((searchResult: ProductRegistrationProductTileViewModel[]) => {
            results.value = searchResult;
            isSearching.value = false;
        });
}

return { __sfc: true,isPrivateMode, searchActive, term, isSearching, results, defaultSearchResult, onTermChange, ProductRegistrationSearchProductTile }
}

})